import Analytics from '@getaccept/lib-shared-new/src/analytics';
import bugsnagClient from '@getaccept/lib-shared-new/src/bugsnag';
import { AnalyticsEvent, AnalyticsUserTrait } from '@getaccept/lib-shared-new/src/types/analytics';
import LocationService from '../location/location.service';
import type { GeoLocation } from '../location/types/geo-location';
import type { ErrorMessage } from '../types/error-message';
import { SignupErrorKey } from '../verify-user/types/enums/signup-error-key';
import type { CreateEntityFormData } from '../create-entity/types/create-entity-form-data';
import CreateEntityService from '../services/create-entity.service';

export class CreateEntityHelper {
  static async createEntity(formData: CreateEntityFormData) {
    try {
      const responseUrl: string = await CreateEntityService.createEntity(formData);
      window.location.href = responseUrl;
    } catch (e) {
      if (bugsnagClient) {
        bugsnagClient.notify(e);
      }
      throw CreateEntityHelper.getErrorMessage(e);
    }
  }

  static async getGeoLocation() {
    try {
      const geoLocation: GeoLocation = await LocationService.getGeoLocation();
      return geoLocation;
    } catch (e) {
      if (bugsnagClient) {
        bugsnagClient.notify(e);
      }
    }
  }
  static getErrorMessage(error: Error) {
    switch (error.message) {
      case SignupErrorKey.EntityAlreadyExists:
        return {
          title: 'entity-name-already-exists',
          description: 'please-try-again-with-a-new-entity-name',
        };
      case SignupErrorKey.EntityNameIsEmpty:
      default:
        return {
          title: 'something-went-wrong',
          description: 'please-try-again-or-contact-support_v2',
        };
    }
  }

  static trackSignupSuccess(isSignup: boolean, userId = '', formData: CreateEntityFormData) {
    if (isSignup) {
      const analyticsData = {
        [AnalyticsUserTrait.Country]: formData.countryCode,
        [AnalyticsUserTrait.DataCenter]: formData.datacenter,
        [AnalyticsUserTrait.SignupStep]: 3,
      };
      Analytics.identify(userId, analyticsData);
      Analytics.track(AnalyticsEvent.SignupLoadedStep3, analyticsData);
    } else {
      const analyticsData = { [AnalyticsUserTrait.SignupStep]: undefined };
      Analytics.track(AnalyticsEvent.SignupCompleted, analyticsData);
      Analytics.identify(undefined, analyticsData);
    }
  }

  static trackSignupError(errorMessage: ErrorMessage) {
    Analytics.track(AnalyticsEvent.SignupFailed, {
      errorMessage: errorMessage.title,
      [AnalyticsUserTrait.SignupStep]: 3,
    });
    Analytics.identify(undefined, {
      [AnalyticsUserTrait.SignupStep]: 3,
    });
  }
}
